module.exports = __webpack_public_path__ + "static/media/thanos-punch.b3528fc2.png";